import React, { useState, Fragment } from "react";

import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { auth } from "../../Firebase/firebase";
import RecentVehicle from "../LandingPage/RecentVehicle/RecentVehicle";
import ResponsivePlayer from "../../Component/UI/Video/Video";
import * as actionCreator from "../../Store/actions/index"
import { priceFormater } from "../Utility/Utility";
import Spinner from "../UI/spinner/Spinner";
import HeartSpin from "../UI/spinner/HeartSpin";
import classes from "./DetailP.module.css";
import carImg from "../../assets/Img/carIMg.png";
import unKnownDealer from "../../assets/Img/unKnownDealer.jpg";
import camera from "../../assets/svg/camera.svg";
import Heart from "../../assets/svg/balckHeart.svg";
import redHeart from "../../assets/svg/redHeart.svg";
import reply from "../../assets/svg/reply.svg";
import Vedio from "../../assets/svg/Vedio.svg";
import rightBlackarrow from "../../assets/svg/rightBlackarrow.svg";
import star from "../../assets/svg/star.svg";
import starHalf from "../../assets/svg/starHalf.svg";
import starOutline from "../../assets/svg/starOutline.svg";
// import like from "../../assets/svg/like.svg";
import LoanCalculator from "./LoanCalculator/LoanCalculator";

const DetailP = (props) => {
    const [shownImg, setshownImg] = useState(null)
    const [comment, setComment] = useState('');
    const [replyComment, setReplyComment] = useState(false);
    const [replyCommentContent, setReplyCommentContent] = useState('')
    const [relycommentId, setRelycommentId] = useState(null);
    let itemTitle;
    let mediaImg = carImg;
    // let hasVideo = props.hasVideo;
    let imgLIst;
    let parentComments = null;
    let childComments = [];
    let DealerImg;
    let user = false;
    let profile_picture;
    let isWishListed = false;
    let wishArray = localStorage.getItem('myWish');
    if (props.user && props.wishIdsArray && wishArray) {
        wishArray = wishArray.split(',');
        isWishListed = wishArray.some((id) => {
            return id === props.itemToRetrive
        })
    }
    const addItmeToWishList = (itemId, userIsAuth) => {
        if (!props.user) {
            props.showAuthHandler('signIn')
        }
        else {
            if (!isWishListed) {
                let token = localStorage.getItem('idToken')
                if (!token) {
                    const fireUser = auth.currentUser
                    if (fireUser) {
                        fireUser.getIdToken().then(newToken => {
                            token = newToken
                            props.AddItemToWishList(itemId, token)
                        })
                    }
                    else {
                        console.log(fireUser)
                    }
                }
                else {
                    props.AddItemToWishList(itemId, token)
                }
            }
            else {
                console.log(itemId, userIsAuth, 'in my WishList')
            }
        }
    };
    if (props.vehicle) {
        itemTitle = props.vehicle.data.title;
        if (props.vehicle.data.media.length >= 1) {
            if (!props.checkingHasVideo) {
                if (props.hasVideo === true) {
                    try {
                        mediaImg = props.vehicle.data.media.filter(img => img.name === 'video')[0].url;
                    } catch (error) {
                        mediaImg = props.vehicle.data.media[0].url
                    }

                } else if (props.hasVideo === false) {
                    try {
                        mediaImg = props.vehicle.data.media.filter(img => img.name === 'front')[0].url;
                    } catch (error) {
                        mediaImg = props.vehicle.data.media[0].url
                    }
                } else {
                    console.log("###############   ERROR ###################")
                    mediaImg = { url: "https://storage.googleapis.com/pcari-71145.appspot.com/media/mp4/tznxtfajA9.mp4" }
                }
            }
            // setshownImg(mediaImg)
            imgLIst = props.vehicle.data.media.map(img => {
                if (img.name !== 'video') {
                    return <img key={img.id} src={img.url} alt='Extra imges'
                        onMouseEnter={() => {
                            setshownImg(img.url)
                            props.onToggelHasVideo(false)
                        }}
                    />
                }
                else {
                    return <video key={img.id}
                        onMouseEnter={() => {
                            setshownImg(false)
                            props.onToggelHasVideo(true)
                        }}>
                        <source src={img.url} type="video/mp4"></source>
                    </video >
                }
            })
        }
        if (props.vehicle.data.comments.length >= 1) {
            parentComments = props.vehicle.data.comments.filter(comment => {
                if (!comment.parent_comment_id) {
                    return comment
                }
                else {
                    childComments.push(comment)
                }
                return null
            })
        }
        DealerImg = props.vehicle.data.seller.profile_picture ? props.vehicle.data.seller.profile_picture : unKnownDealer
    }
    if (props.user) {
        user = true
    }
    if (props.currentUser) {
        profile_picture = props.currentUser.profile_picture
    }
    return (
        props.itemLoading ?
            <Spinner />
            :
            <div className={classes.DetailPage}>
                <div className={classes.BreadCrumb}>
                    <p>
                        <NavLink to='/'>
                            HOME
                    </NavLink>
                    </p>
                    <img src={rightBlackarrow} alt='' />
                    <p>
                        {localStorage.getItem('vehicleType')}
                    </p>
                    <img src={rightBlackarrow} alt='' />
                    <p>{props.vehicle ? itemTitle : null}</p>
                </div>
                {props.vehicle ?
                    <div className={classes.Continer}>
                        <div className={classes.Row}>
                            <div className={classes.ItemCenter}>
                                <div className={classes.MainImage}>
                                    {props.hasVideo ?
                                        <ResponsivePlayer url={mediaImg} />
                                        :
                                        <img src={!shownImg ? mediaImg : shownImg} alt='Vehicle' />}
                                    <div className={classes.positioningCamera}>
                                        <img src={camera} alt='' /><small>{props.vehicle.data.media.length} +</small>
                                    </div>
                                    {props.addingItem ?
                                        <div className={classes.AddingWish}>
                                            <HeartSpin />
                                        </div>
                                        :
                                        <div
                                            className={classes.positioningHeart}
                                            onClick={() => {
                                                addItmeToWishList(props.itemToRetrive, props.user !== null)
                                            }}>
                                            <img src={isWishListed ? redHeart : Heart} alt='' />
                                        </div>
                                    }
                                    {props.hasVideo ?
                                        <div className={classes.positioningHeart}>
                                            <img src={Vedio} alt='' />
                                        </div>
                                        : null}
                                </div>
                                <div className={`${classes.Row} ${classes.ImgSList}`}>
                                    {imgLIst}
                                </div>
                                <h2>Technical Specs</h2>
                                <div className={`${classes.Row} ${classes.TechnicalInfos}`}>
                                    <div className={classes.ColInfo}>
                                        <p className={classes.infoTitle}>Driven :</p>
                                        <p className={classes.Techinfo}>{props.vehicle.data.driven_wheel}</p>
                                    </div>
                                    <div className={classes.ColInfo}>
                                        <p className={classes.infoTitle}>Origin :</p>
                                        <p className={classes.Techinfo}>{props.vehicle.data.origin}</p>
                                    </div>
                                    <div className={classes.ColInfo}>
                                        <p className={classes.infoTitle}>Transmission :</p>
                                        <p className={classes.Techinfo}>{props.vehicle.data.transmission}</p>
                                    </div>
                                    <div className={classes.ColInfo}>
                                        <p className={classes.infoTitle}>Fuel :</p>
                                        <p className={classes.Techinfo}>{props.vehicle.data.fuel_type}</p>
                                    </div>
                                    <div className={classes.ColInfo}>
                                        <p className={classes.infoTitle}>Mileage :</p>
                                        <p className={classes.Techinfo}>{props.vehicle.data.mileage}Km</p>
                                    </div>
                                    <div className={classes.ColInfo}>
                                        <p className={classes.infoTitle}>Location :</p>
                                        <p className={classes.Techinfo}>{props.vehicle.data.state ? props.vehicle.data.state.name : null}</p>
                                    </div>
                                </div>
                                <h2>Sellers Pitch</h2>
                                <div className={classes.Seller_pitch}>
                                    <p>{props.vehicle.data.seller_pitch}</p>
                                    {props.showMore ? <p>{props.vehicle.data.extra_seller_pitch}</p> : null}
                                </div>
                                <div className={classes.Row}>
                                    <button className={classes.Btn}
                                        type='button'
                                        onClick={() => {
                                            props.showMoreHandler()
                                        }}>
                                        {!props.showMore ? 'Show More' : 'Show Less'}
                                    </button>
                                </div>
                            </div>
                            <div className={classes.RightItems}>
                                <div className={classes.DealerContact}>
                                    <h1>{props.vehicle.data.title}</h1>
                                    <div className={classes.Dealer}>
                                        <div className={classes.DealerInfo}>
                                            <img src={DealerImg} alt='Dealer' width='50px' height='50px' />
                                            <div className={classes.DealerDetila}>
                                                <h2>{props.vehicle.data.seller.name}</h2>
                                                <p> {props.vehicle.data.seller.company_name ? 'Company' : 'Private'} {/*<img src={like} width='14%' alt='' />*/}</p>
                                                <div>
                                                    <img src={star} alt='' />
                                                    <img src={star} alt='' />
                                                    <img src={star} alt='' />
                                                    <img src={starHalf} alt='' />
                                                    <img src={starOutline} alt='' />
                                                </div>
                                            </div>
                                        </div>
                                        <button className={classes.BtnBig}>
                                            RM {priceFormater(props.vehicle.data.price)} 
                                    </button>
                                        <button
                                            className={classes.BtnColored}
                                            onClick={() => { props.onToggelContactNow(props.vehicle.data.seller.id, props.vehicle.data.seller.name, props.vehicle.data.seller.phone) }}>
                                            Contact Now
                                    </button>
                                    </div>
                                </div>
                                <div className={classes.DealerContact}>
                                    <LoanCalculator />
                                </div>
                            </div>
                        </div>
                        <div className={classes.Row}>
                            <div className={classes.OnlySmallScreen}>
                                <div className={classes.DealerContact}>
                                    <h1>{props.vehicle.data.title}</h1>
                                    <div className={classes.Dealer}>
                                        <div className={classes.DealerInfo}>
                                            <img src={DealerImg} alt='Dealer' width='50px' height='50px' />
                                            <div className={classes.DealerDetila}>
                                                <h2>{props.vehicle.data.seller.name}</h2>
                                                <p> {props.vehicle.data.seller.company_name ? 'Company' : 'Private'} {/*<img src={like} width='14%' alt='' />*/}</p>
                                                <div>
                                                    <img src={star} alt='' />
                                                    <img src={star} alt='' />
                                                    <img src={star} alt='' />
                                                    <img src={starHalf} alt='' />
                                                    <img src={starOutline} alt='' />
                                                </div>
                                            </div>
                                        </div>
                                        <button className={classes.BtnBig}>
                                            RM {priceFormater(props.vehicle.data.price)} 
                                    </button>
                                        <button
                                            className={classes.BtnColored}
                                            onClick={() => { props.onToggelContactNow(props.vehicle.data.seller.id, props.vehicle.data.seller.name, props.vehicle.data.seller.phone) }}>
                                            Contact Now
                                    </button>
                                    </div>
                                </div>
                                <div className={`${classes.DealerContact} ${classes.OnlyMediumSecren}`}>
                                    <LoanCalculator />
                                </div>
                            </div>
                        </div>
                        <div className={classes.Row}>
                            <div className={classes.ItemCenter}>
                                <h2 style={{ borderTop: 'none' }}>Comments</h2>
                                <div className={classes.Comments}>
                                    {parentComments ?
                                        parentComments.map(comment => {
                                            const nestedComments = {}
                                            nestedComments[`nested${comment.id}`] = childComments.filter(nested => {
                                                return nested.parent_comment_id === comment.id
                                            });
                                            return (
                                                <Fragment key={comment.id}>
                                                    <div className={classes.ParentComment}>
                                                        <img src={comment.user.profile_picture} alt='' />
                                                        <div className={classes.InnerComment}>
                                                            <p>{comment.user.name ? comment.user.name : comment.user.email}<small>{new Date(comment.created_at).toString().slice(4, 15)}</small></p>
                                                            <p>{comment.content}</p>
                                                            {props.user ?
                                                                <div className={classes.BtnsComments} >
                                                                    {replyComment && comment.id === relycommentId ?
                                                                        <form
                                                                            className={`${classes.AddComment} ${classes.BtnsComments}`}
                                                                            onSubmit={(event => {
                                                                                event.preventDefault()
                                                                                const vehicleType = localStorage.getItem('vehicleType');
                                                                                let token = localStorage.getItem('idToken');
                                                                                const vehicleId = props.vehicle.data.id;
                                                                                if (replyCommentContent.trim() !== '') {
                                                                                    if (!token) {
                                                                                        const fireUser = auth.currentUser;
                                                                                        if (fireUser) {
                                                                                            console.log(fireUser)
                                                                                            fireUser.getIdTokenResult(true).then(res => {
                                                                                                localStorage.setItem('idToken', res.token)
                                                                                                token = localStorage.getItem('idToken');
                                                                                                props.onPostAddComment(vehicleType, vehicleId, token, replyCommentContent, comment.id)
                                                                                                setTimeout(() => {
                                                                                                    localStorage.removeItem('idToken')
                                                                                                }, 3600 * 1000);

                                                                                            })
                                                                                        } else {
                                                                                            console.log(fireUser)
                                                                                        }
                                                                                    } else {
                                                                                        props.onPostAddComment(vehicleType, vehicleId, token, replyCommentContent, comment.id)
                                                                                    }
                                                                                    setReplyComment(false);
                                                                                    setReplyCommentContent('')

                                                                                }
                                                                            })}>
                                                                            <input
                                                                                type='text'
                                                                                placeholder='Your reply ...'
                                                                                autoFocus
                                                                                value={replyCommentContent}
                                                                                onChange={(event) =>
                                                                                    setReplyCommentContent(event.target.value)
                                                                                } />
                                                                            <button type='submit'>post</button>
                                                                        </form>
                                                                        :
                                                                        null}
                                                                    {/* <button type='button'><img src={Heart} alt='' width='12.59px' />Like</button>
                                                            <button type='button'><img src={brokenHeart} alt='' />Dislike</button> */}
                                                                    <button
                                                                        type='button'
                                                                        onClick={() => {
                                                                            setReplyComment(true);
                                                                            setRelycommentId(comment.id);
                                                                        }}
                                                                    ><img src={reply} alt='' />Reply</button>
                                                                </div>
                                                                :
                                                                null}
                                                        </div>
                                                    </div>
                                                    {nestedComments[`nested${comment.id}`].map((child, i) => {
                                                        return (
                                                            <div key={child.id} className={classes.ChildComment}>
                                                                <img src={child.user.profile_picture} alt='' />
                                                                <div className={classes.InnerComment}>
                                                                    <p>{child.user.name ? child.user.name : child.user.email}<small>{new Date(child.created_at).toString().slice(4, 15)}</small></p>
                                                                    <p>{child.content}</p>
                                                                    <div className={classes.BtnsComments}>
                                                                        {/* <button type='button'><img src={Heart} alt='' width='12.59px' />Like</button>
                                                                        <button type='button'><img src={brokenHeart} alt='' />Dislike</button> 
                                                                        <button type='button'><img src={reply} alt='' />Reply</button>*/}
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        );
                                                    })}
                                                </Fragment>
                                            );
                                        })
                                        :
                                        <p>no comments</p>
                                    }
                                    {props.user ?
                                        <form
                                            className={`${classes.AddComment} ${classes.BtnsComments}`}
                                            onSubmit={event => {
                                                event.preventDefault()
                                                const vehicleType = localStorage.getItem('vehicleType');
                                                const token = localStorage.getItem('idToken');
                                                const vehicleId = props.vehicle.data.id;
                                                props.onPostAddComment(vehicleType, vehicleId, token, comment, null)
                                            }}>
                                            <img src={profile_picture} alt='' width='30px' />
                                            <input
                                                type='text'
                                                placeholder='add comment'
                                                value={comment}
                                                onChange={(event) =>
                                                    setComment(event.target.value)
                                                } />
                                            <button type='submit'> post</button>
                                        </form>
                                        :
                                        null}

                                </div>
                            </div>
                        </div>
                        <div className={classes.Row}>
                            <div className={classes.OnlySmallestScreen}>
                                <div className={classes.DealerContact}>
                                    <LoanCalculator />
                                </div>
                            </div>
                        </div>
                        <h1 className={classes.FeatruedVehicles}>Featured Vehicles</h1>
                        <div className={classes.Row}>
                            {props.FeatruedVehicles ?
                                <RecentVehicle
                                    FeatruedVehicles={props.FeatruedVehicles}
                                    routeHistory={props.routeHistory}
                                    reload={props.reloadPage}
                                    user={props.user}
                                    wishIdsArray={props.wishIdsArray}
                                    AddItemToWishList={props.AddItemToWishList}
                                    showAuthHandler={props.showAuthHandler}
                                    addingItem={props.addingItem} />
                                :
                                <Spinner />
                            }
                        </div>
                    </div>
                    :
                    null}
            </div>
    );
};

const mapStateToProps = state => {
    return {
        currentUser: state.Auth.currentUser
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onToggelHasVideo: (hasVideo) => { dispatch(actionCreator.chechItemHasVideo(hasVideo)) },
        onPostAddComment: (vehicleType, vehicleId, token, content, parentId) => {
            dispatch(actionCreator.postAddComment(vehicleType, vehicleId, token, content, parentId))
        },
        onToggelContactNow: (id, name, phone) => { dispatch(actionCreator.toggelContactShow(id, name, phone)) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DetailP);